/* @flow */
import * as React from 'react';

import AddButton from 'components/AddButton';
import AddFamilyModal from 'users/components/AddFamilyModal';
import HoverLayerTrigger from 'components/HoverLayerTrigger';
import ModalTrigger from 'components/ModalTrigger';
import Tooltip from 'components/Tooltip';
import GroupMemberFamilyList from 'groups/components/GroupMemberFamilyList';

import type { DirectAddFamilyOptions } from 'users/components/AddFamilyModal';

import './styles/GroupMemberFamily.scss';

export type Props = {
  addButtonOnClick?: Function,
  addFamilyModalEventPrefix?: string,
  canAddChild: boolean,
  canAddParent: boolean,
  directAddOptions?: ?DirectAddFamilyOptions,
  familySummary: ?Object,
  maxProfilePics: number,
  orientation: 'horizontal' | 'vertical',
  onAddFamilyMember?: () => void,
  staticProfilePicture?: boolean,
  userId: number,
  userUuid?: string,
  onFamilyMemberClick?: Function,
};

type State = {
  hovered: boolean,
};

export default class GroupMemberFamily extends React.Component<Props, State> {
  state: State = {
    hovered: false,
  };

  static defaultProps = {
    maxProfilePics: 5,
    orientation: 'horizontal',
  };

  setHoverTrue = () => {
    this.setState({ hovered: true });
  };

  setHoverFalse = () => {
    this.setState({ hovered: false });
  };

  render = () => {
    const {
      addButtonOnClick,
      addFamilyModalEventPrefix,
      canAddChild,
      canAddParent,
      directAddOptions,
      familySummary,
      maxProfilePics,
      orientation,
      onAddFamilyMember,
      staticProfilePicture,
      userId,
      userUuid,
      onFamilyMemberClick,
    } = this.props;
    const { hovered } = this.state;

    if (!familySummary) {
      return <div />;
    }

    const familyIsEmpty = familySummary.parents.length + familySummary.children.length === 0;
    const canAddFamilyMember = canAddChild || canAddParent;
    const relation = canAddChild ? 'child' : 'parent';

    const addFamilyMemberModal = (
      <AddFamilyModal
        directAddOptions={directAddOptions}
        eventPrefix={addFamilyModalEventPrefix}
        relationToAdd={relation}
        selfId={userId}
        selfUuid={userUuid}
        onAddFamilyMember={onAddFamilyMember}
      />
    );

    if (orientation === 'vertical') {
      if (familyIsEmpty && !canAddFamilyMember) {
        return null;
      }

      return (
        <div className="GroupMemberFamily">
          {!familyIsEmpty && (
            <GroupMemberFamilyList
              familySummary={familySummary}
              maxProfilePics={maxProfilePics}
              orientation={orientation}
              staticProfilePicture={staticProfilePicture}
              onFamilyMemberClick={onFamilyMemberClick}
            />
          )}
          {canAddFamilyMember && (
            <ModalTrigger modal={addFamilyMemberModal}>
              <AddButton listFooter size="large" onClick={addButtonOnClick}>
                Add a family member
              </AddButton>
            </ModalTrigger>
          )}
        </div>
      );
    }

    return (
      <div
        onMouseEnter={this.setHoverTrue}
        onMouseLeave={this.setHoverFalse}
        className="GroupMemberFamily-item-list">
        <GroupMemberFamilyList
          familySummary={familySummary}
          maxProfilePics={maxProfilePics}
          staticProfilePicture={staticProfilePicture}
          onFamilyMemberClick={onFamilyMemberClick}
        />
        {canAddFamilyMember &&
          (familyIsEmpty || hovered) && (
            <HoverLayerTrigger
              layer={<Tooltip>{`Connect a ${relation}`}</Tooltip>}
              alignment="middle"
              placement="bottom">
              <ModalTrigger modal={addFamilyMemberModal}>
                <AddButton size="large" onClick={addButtonOnClick} />
              </ModalTrigger>
            </HoverLayerTrigger>
          )}
      </div>
    );
  };
}
